import moment from "moment";
import { 
  UserIcon, 
  AtSymbolIcon, 
  ClockIcon, 
  BuildingOfficeIcon 
} from '@heroicons/react/24/solid';
import { SparklesIcon } from '@heroicons/react/24/outline';

// RTK Query
import { 
  useGetUserGrowthSparkRequestsQuery 
} from "@/features/userGrowthSparkRequests/userGrowthSparkRequestsApiSlice";

const EtAdminGrowthSparks = () => {
  
    // First Created (original) - 15 Oct 2025
  // Refactored for Trinity Web Admin - 29 Nov 2025
  // Author - Atul Pandey

  // 1 - Fetch Data
  const { data: growthSparkData, isLoading, error, refetch } =
    useGetUserGrowthSparkRequestsQuery();

  // 2 - Extract Entities (your existing adapter logic)
  const extractEntities = (adapterData) =>
    adapterData?.ids?.map(id => adapterData.entities[id]) || [];

  const sparkList = extractEntities(growthSparkData)
    ?.slice()
    ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    console.log('sparkList', sparkList)

  // 3 - Loading / Error States
  if (isLoading) {
    return <p className="text-sm text-gray-600">Loading Growth Sparks...</p>;
  }

  if (error) {
    return <p className="text-sm text-red-600">Error loading sparks.</p>;
  }

  return (
    <div>

      {/* Section Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-orange-600">
          Growth Spark Requests
        </h2>

        <div className="bg-orange-50 border border-orange-600 text-orange-800 px-3 py-1 rounded-full text-xs font-semibold">
          {sparkList.length} total
        </div>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {sparkList.map((item, idx) => (
          <div 
            key={item._id + idx} 
            className="bg-white rounded shadow-md p-4 space-y-2 border border-gray-100"
          >
            
            {/* Name + Role */}
            <div className="flex items-center gap-2 border-b pb-1">
              <UserIcon className="h-5 w-5 text-orange-600" />
              <div>
                <p className="text-sm font-bold text-gray-800">{item.name}</p>
                <p className="text-xs italic text-gray-500">{item.role}</p>
              </div>
            </div>

            {/* Org */}
            <div className="flex items-center gap-2 text-xs text-gray-600">
              <BuildingOfficeIcon className="h-4 w-4 text-orange-600" />
              {item.organizationName}
            </div>

            {/* Email */}
            <div className="flex items-center gap-2 text-xs text-gray-600">
              <AtSymbolIcon className="h-4 w-4 text-orange-600" />
              {item.email}
            </div>

            {/* Date */}
            <div className="flex items-center gap-2 text-xs text-gray-600">
              <ClockIcon className="h-4 w-4 text-lime-600" />
              {moment(item.createdAt).format("DD MMM YYYY, hh:mm A")}
            </div>

            {/* Growth Prompt */}
            <div className="mt-2 border-t pt-2 text-xs text-gray-700">
              <p className="font-semibold text-orange-600">Growth Prompt:</p>
              <p className="text-gray-600">{item.growthPrompt}</p>
            </div>

            {/* AI Response */}
            {item.aiGeneratedResponse && (
              <div className="mt-2 border-t pt-2 text-xs text-gray-700">
                <p className="flex items-center gap-1 font-semibold text-orange-600">
                  <SparklesIcon className="h-4 w-4" />
                  Trinity Growth Spark
                </p>
                <div
                  className="text-gray-700 leading-snug mt-1 text-xs"
                  dangerouslySetInnerHTML={{ __html: item.aiGeneratedResponse }}
                />
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
};

export default EtAdminGrowthSparks;